module.exports = __webpack_public_path__ + "static/media/coconut.5e01d4ba.png";